import { render, staticRenderFns } from "./AllCategories.vue?vue&type=template&id=01d146c8&scoped=true"
import script from "./AllCategories.vue?vue&type=script&lang=js"
export * from "./AllCategories.vue?vue&type=script&lang=js"
import style0 from "./AllCategories.vue?vue&type=style&index=0&id=01d146c8&prod&lang=scss&scoped=true"
import style1 from "./AllCategories.vue?vue&type=style&index=1&id=01d146c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d146c8",
  null
  
)

export default component.exports